import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ref, get, onValue, push, update } from "firebase/database";
import { db } from "../../../../assets/firebase/firebaseconfig";
import Loading from "../../../Loading";
const RatingSection = ({ productId }) => {
  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState("");
  const [replyInputs, setReplyInputs] = useState({});
  const navigate = useNavigate();

  // Lấy thông tin user hiện tại từ localStorage
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const isAdminC =
    currentUser?.role === "Admin" ||
    currentUser?.type === "admin" ||
    currentUser?.role === "Staff" ||
    currentUser?.type === "Staff";
  useEffect(() => {
    if (!productId) return;
    const commentsRef = ref(db, "comments");
    const unsubscribe = onValue(commentsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data)
          .map((key) => ({ id: key, ...data[key] }))
          .filter((c) => c.productId === productId);
        setComments(
          list.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
      } else {
        setComments([]);
      }
    });
    return () => unsubscribe();
  }, [productId]);

  // 1. Gửi đánh giá/câu hỏi ban đầu
  console.log("currentUse", currentUser);
  const handleSubmit = () => {
    if (!commentText.trim()) return;
    if (!currentUser) {
      alert("Vui lòng đăng nhập để gửi đánh giá!");
      navigate("/dang-nhap");
      return;
    }

    const newComment = {
      productId,
      userId: currentUser.uid || currentUser.id,
      userName: currentUser.username || currentUser.name || "Nguời dùng",
      content: commentText,
      createdAt: new Date().toISOString(),
      chatHistory: [], // Khởi tạo mảng hội thoại
      status: "Đợi trả lời",
    };

    push(ref(db, "comments"), newComment).then(() => {
      setCommentText("");
    });
  };

  // 2. Gửi tin nhắn phản hồi (Dùng chung cho cả Admin và User chủ bài viết)
  const handleSendMessage = (commentId, currentChatHistory = []) => {
    const text = replyInputs[commentId];
    if (!text?.trim()) return;

    // Kiểm tra quyền: Admin hoặc User (chủ bài viết)
    const isAdmin =
      currentUser?.role === "admin" || currentUser?.type === "admin";

    const newMessage = {
      sender: isAdminC ? "Admin" : "User",
      text: text,
      time: new Date().toISOString(),
      senderName: currentUser.username || currentUser.name || "Người dùng",
    };

    const updatedHistory = [...(currentChatHistory || []), newMessage];

    update(ref(db, `comments/${commentId}`), {
      chatHistory: updatedHistory,
      // Nếu Admin phản hồi thì đổi trạng thái thành "Đã xong"
      status: isAdmin ? "Đã xong" : "Đợi trả lời",
    }).then(() => {
      setReplyInputs({ ...replyInputs, [commentId]: "" });
    });
  };

  return (
    <div
      style={{
        
        padding: "20px",
        fontFamily: "Arial",
      }}
    >
      <h3 style={{ borderLeft: "4px solid #ee4d2d", paddingLeft: "10px" }}>
        Đánh Giá Của Khách Hàng
      </h3>

      {}
      {!isAdminC && (
        <div style={{ margin: "20px 0" }}>
          <textarea
            style={{
              width: "100%",
              minHeight: "80px",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ddd",
            }}
            placeholder="Hỏi đáp về sản phẩm..."
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
          />
          <button
            onClick={handleSubmit}
            style={{
              marginTop: "10px",
              background: "#ee4d2d",
              color: "#fff",
              border: "none",
              padding: "10px 20px",
              cursor: "pointer",
            }}
          >
            Gửi câu hỏi
          </button>
        </div>
      )}
      {}
      <div>
        {comments.map((cmt) => {
          console.log("cmt", cmt);
          const loginId = currentUser?.uid || currentUser?.id;
          const isOwner = loginId && String(loginId) === String(cmt.userId);
          const isAdmin =
            currentUser?.role === "Admin" ||
            currentUser?.type === "admin" ||
            currentUser?.role === "Staff" ||
            currentUser?.type === "Staff";

          return (
            <div
              key={cmt.id}
              style={{
                border: "1px solid #eee",
                padding: "15px",
                marginBottom: "15px",
                borderRadius: "8px",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <strong>👤 {cmt.userName}</strong>
                <span style={{ fontSize: "12px", color: "#999" }}>
                  {new Date(cmt.createdAt).toLocaleString()}
                </span>
              </div>
              <p style={{ margin: "10px 0", color: "#333" }}>{cmt.content}</p>

              {}
              <div
                style={{
                  marginLeft: "20px",
                  paddingLeft: "15px",
                  borderLeft: "2px solid #f9f9f9",
                }}
              >
                {cmt.chatHistory?.map((chat, index) => (
                  <div
                    key={index}
                    style={{
                      marginBottom: "10px",
                      textAlign: chat.sender === "Admin" ? "left" : "right",
                    }}
                  >
                    <div
                      style={{
                        display: "inline-block",
                        padding: "8px 12px",
                        borderRadius: "12px",
                        background:
                          chat.sender === "admin" ? "#f1f1f1" : "#e3f2fd",
                        fontSize: "14px",
                      }}
                    >
                      <b
                        style={{
                          display: "block",
                          fontSize: "11px",
                          color:
                            chat.sender === "Admin" ? "#ee4d2d" : "#007bff",
                        }}
                      >
                        {chat.sender === "Admin"
                          ? "HABAKO (Admin)"
                          : cmt.userName}
                      </b>
                      {chat.text}
                    </div>
                  </div>
                ))}
              </div>

              {}
              {(isAdmin || isOwner) && (
                <div
                  style={{ display: "flex", marginTop: "15px", gap: "10px" }}
                >
                  <input
                    style={{
                      flex: 1,
                      padding: "8px",
                      border: "1px solid #ddd",
                    }}
                    placeholder={
                      isAdmin ? "Trả lời khách hàng..." : "Nhắn tin cho Shop..."
                    }
                    value={replyInputs[cmt.id] || ""}
                    onChange={(e) =>
                      setReplyInputs({
                        ...replyInputs,
                        [cmt.id]: e.target.value,
                      })
                    }
                  />
                  <button
                    onClick={() => handleSendMessage(cmt.id, cmt.chatHistory)}
                    style={{
                      background: isAdmin ? "#28a745" : "#007bff",
                      color: "#fff",
                      border: "none",
                      padding: "0 15px",
                      cursor: "pointer",
                    }}
                  >
                    Gửi
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RatingSection;
